import type BaseStore from '@stores/base/base.store';
import {
  type ActionType,
  type AtomType,
  ResolvedVariableType,
  type TableImporterAction
} from '@stratumn/studio-shared';
import type { AtomWithTitle } from '@/types/atom';

import { ActionModel } from './action.model';

export class TableImporterActionModel extends ActionModel {
  public actionType = 'TABLE_IMPORTER' as const satisfies ActionType;
  constructor(store: BaseStore<ActionModel>, action: TableImporterAction) {
    super(store, action);
    const processId = this.store.rootStore.processStore
      .toArray()
      .find(process =>
        process.workflows.some(workflow => workflow.id === this.workflowId)
      )?.id;
    if (!processId) {
      return;
    }
    this.createTableAtom(processId);
  }

  get metadata() {
    return this._metadata as TableImporterAction['metadata'];
  }
  // todo fix with atom id
  public createTableAtom(processId: string) {
    if (this.atom) {
      return;
    }
    const atomStore = this.store.rootStore.atomStore;

    return atomStore.createAtom(
      this.id,
      'variable' as AtomType,
      {
        title: 'Table Importer'
      },
      {
        source: {
          elementId: this.id,
          name: 'Imported table',
          parentKind: 'ui',
          parentId: this.id
        }
      },
      processId,
      {
        resolvedType: ResolvedVariableType.Table
      }
    ) as Maybe<AtomWithTitle>;
  }

  get atom() {
    const atomStore = this.store.rootStore.atomStore;
    return atomStore.getAtomById_Unsafe(this.id) as Maybe<AtomWithTitle>;
  }
}
